import type React from 'react'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useNavigate } from 'react-router-dom'
import type { ICellRendererParams } from 'ag-grid-community'
import { handleNavigation } from '../../utils/navigationHelpers'

interface SupplierNameClickableCellRendererProps extends ICellRendererParams {
  data: {
    supplier_name: string
  }
  context?: {
    assignedToMe?: boolean
    dateRange?: {
      start: Date
      end: Date
    }
  }
}

export function SupplierNameClickableCellRenderer({ data, context }: SupplierNameClickableCellRendererProps) {
  const navigate = useNavigate()
  const assignedToMe = context?.assignedToMe || false
  const dateRange = context?.dateRange

  function createMatchViewUrl(baseUrl: string) {
    if (!dateRange) {
      return baseUrl
    }

    const params = new URLSearchParams()
    params.append('date_range[]', dateRange.start.toISOString())
    params.append('date_range[]', dateRange.end.toISOString())

    return `${baseUrl}?${params.toString()}`
  }

  function handleClick(event: React.MouseEvent) {
    if (data?.supplier_name) {
      const baseUrl = createMatchViewUrl('/supplier_rec/match_view')
      const assignedParam = assignedToMe ? '&assigned_to_me=true' : '&assigned_to_me=false'
      const url = `${baseUrl}&supplier_name=${encodeURIComponent(data.supplier_name)}${assignedParam}`
      handleNavigation(url, navigate, event)
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start' }}>
      <GraviButton
        appearance='link'
        size='small'
        onClick={handleClick}
        style={{
          textAlign: 'left',
          padding: 0,
          fontSize: '12px',
          color: 'var(--gray-500)',
          minWidth: 'auto',
          textDecoration: 'none',
          cursor: 'pointer',
          height: 'auto',
          lineHeight: 'normal',
        }}
      >
        <Texto category='p2' appearance='secondary' style={{ fontSize: '12px', textDecoration: 'underline' }}>
          {data?.supplier_name || 'N/A'}
        </Texto>
      </GraviButton>
    </div>
  )
}
